import React from 'react';
import { observer } from "mobx-react-lite";
import { MapElementSelector } from '../../selector/MapElementSelector';
import { useTranslation } from 'react-i18next';
import { formatTreeParameter } from "../../../../../shared/helper/actionTreeHelper";
import { editorMapStore, MapStatus } from '../../../../stores/EditorMapStore';
import { getTreeParentOfClosestActionModel } from '../../../../../shared/action/ActionTreeModel';
import { getIconForElement, getImageForElement } from '../../../../helper/mapElementIconHelper';
import { ElementIconAreaTrigger, ElementIconType, ElementIconViewAreaTrigger, ElementParameter } from '../../../editor/ElementIcons';
import { ElementGroup, ElementLabel } from './BaseElements';
import { DynamicMapElementAreaTriggerModel } from '../../../../../shared/game/dynamicMapElements/DynamicMapElementAreaTriggerModel';
import { ViewAreaTriggerModel } from '../../../../../shared/game/ViewAreaTriggerModel';
export const MapElementSelectionDetail = observer(({
  name,
  selectedElement,
  elementSetter,
  getSelectableElements,
  parameterTypes,
  allowBlankValue,
  limitedToMapId
}) => {
  const {
    t
  } = useTranslation();
  const parentTree = getTreeParentOfClosestActionModel(selectedElement, true);
  const parameters = parameterTypes.map(parameterType => parentTree.treeParameterActions(parameterType).map(treeParam => formatTreeParameter(treeParam.name))).flat();

  const getElements = mapId => {
    if (mapId === 0) {
      return {
        mapStatus: MapStatus.Loaded,
        mapName: undefined,
        elements: parameters.map(parameter => ({
          id: parameter,
          label: parameter,
          icon: /*#__PURE__*/React.createElement(ElementParameter, {
            key: parameter
          })
        }))
      };
    }

    if (limitedToMapId != undefined && mapId !== limitedToMapId) {
      return {
        mapStatus: MapStatus.Loaded,
        mapName: "",
        elements: []
      };
    }

    const {
      map,
      mapStatus
    } = editorMapStore.getOrLoadMapWithMetaData(mapId, true);
    let mapElements = map ? getSelectableElements(map, t) : [];
    const hasAreaTriggerWithId = new Set();
    const hasViewAreaTriggerWithId = new Set();

    for (const mapElement of mapElements) {
      const {
        id,
        element
      } = mapElement;

      if (element instanceof DynamicMapElementAreaTriggerModel) {
        hasAreaTriggerWithId.add(id);
      } else if (element instanceof ViewAreaTriggerModel) {
        hasViewAreaTriggerWithId.add(id);
      }
    } // make sure each ID is unique in the list (e.g. Area Triggers can have multiple instances)


    mapElements = Array.from(new Set(mapElements.map(e => e.id))).map(someId => mapElements.find(m => m.id === someId));
    return {
      mapStatus,
      mapName: map === null || map === void 0 ? void 0 : map.properties.name,
      elements: mapElements.map(e => ({
        id: e.id,
        label: e.label,
        image: getImageForElement(e.element),
        icon: hasAreaTriggerWithId.has(e.id) && hasViewAreaTriggerWithId.has(e.id) ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ElementIconAreaTrigger, {
          type: ElementIconType.ActionEditorSelector
        }), "\xA0", /*#__PURE__*/React.createElement(ElementIconViewAreaTrigger, null)) : getIconForElement(e.element)
      }))
    };
  };

  return /*#__PURE__*/React.createElement(ElementGroup, null, name && /*#__PURE__*/React.createElement(ElementLabel, null, name), /*#__PURE__*/React.createElement(MapElementSelector, {
    selectedElement: selectedElement,
    elementSetter: elementSetter,
    elementsGetter: getElements,
    allowBlankValue: allowBlankValue,
    parameterTypes: parameterTypes,
    limitedToMapId: limitedToMapId
  }));
});